module.exports = __webpack_public_path__ + "img/chr_ts_26_penlight.385f0bc2.png";